import Avatar from '@material-ui/core/Avatar';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import VpnKeyRoundedIcon from '@material-ui/icons/VpnKeyRounded';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme = {}) => ({
  avatar: {
    backgroundColor: 'var(--primary-v2)',
  },
}));

export const LockAvatar = () => {
  const classes = useStyles({});
  
  return (
    <Avatar className={classes.avatar}>
      <LockOutlinedIcon />
    </Avatar>
  );
}

export const KeyAvatar = () => {
  const classes = useStyles({});
  
  return (
    <Avatar className={classes.avatar}>
      <VpnKeyRoundedIcon />
    </Avatar>
  );
}

export default LockAvatar;
